var initializeBlockCallToAction = function(block){
    var $block = jQuery(block);
    var $cta = $block.find('.wp-block-call-to-action');
    
    // Check if CTA is the last child in a group
    if($cta.length && $cta.is(':last-child')){
        $block.addClass('has-cta-overlap');
    } 
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-group').each(function(){
        initializeBlockCallToAction(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=call-to-action', initializeBlockCallToAction);
